// Angular import
import { Component, inject, Input, OnInit } from '@angular/core';
import { Location, LocationStrategy } from '@angular/common';

// project import
import { NavigationItem } from 'src/app/@theme/types/navigation';
import { ThemeLayoutService } from 'src/app/@theme/services/theme-layout.service';
import { COMPACT, HORIZONTAL, VERTICAL } from 'src/app/@theme/const';
import { AuthResourceService } from '@mri/app/resources';
import { forkJoin, mergeMap, of, Subject, Subscription, tap } from 'rxjs';
import { User } from '../../../../../types/user-joint';
import { Property } from 'src/types/property';
import { Router } from '@angular/router';
import { catchError } from 'rxjs/operators';
import { PermissionKey } from '@mri/enums';
import { ChangePropertyDialogComponent } from '@mri/app/modules';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-vertical-menu',
  templateUrl: './vertical-menu.component.html',
  styleUrls: ['./vertical-menu.component.scss']
})
export class VerticalMenuComponent implements OnInit {
  private _dialog = inject(MatDialog);

  private _subscription = new Subscription();
  private _menu$ = new Subject<NavigationItem[]>();

  // public props
  user?: User;
  property?: Property;
  menuResult: NavigationItem[];

  @Input() set menus(menus: NavigationItem[]){
    this._menu$.next(menus);
  }

  showContent = true;

  // Constructor
  constructor(
    private location: Location,
    private locationStrategy: LocationStrategy,
    private layout: ThemeLayoutService,
    private _authSrcSrv: AuthResourceService,
    private _router: Router
  ) {
    this._subscription.add(
      this._menu$.pipe(
        mergeMap(menu => forkJoin([of(menu), this._authSrcSrv.auth$])),
        tap(([menu, auth]) => {
          const permissionKeys: PermissionKey[] = auth?.session?.permissions.map(p=> p.key) || [];

          //console.log({permissionKeys});
          this.menuResult = menu.filter( item => !Array.isArray(item.permissions) || item.permissions.every(element => permissionKeys.includes(element)))
        })
      ) .subscribe()
    );

  }


  // public method
  fireOutClick() {
    let current_url = this.location.path();
    const baseHref = this.locationStrategy.getBaseHref();
    if (baseHref) {
      current_url = baseHref + this.location.path();
    }
    const link = 'a.nav-link[ href=\'' + current_url + '\' ]';
    const ele = document.querySelector(link);
    if (ele !== null && ele !== undefined) {
      const parent = ele.parentElement;
      const up_parent = parent?.parentElement?.parentElement;
      const last_parent = up_parent?.parentElement;
      if (parent?.classList.contains('coded-hasmenu')) {
        parent.classList.add('coded-trigger');
        parent.classList.add('active');
      } else if (up_parent?.classList.contains('coded-hasmenu')) {
        up_parent.classList.add('coded-trigger');
        up_parent.classList.add('active');
      } else if (last_parent?.classList.contains('coded-hasmenu')) {
        last_parent.classList.add('coded-trigger');
        last_parent.classList.add('active');
      }
    }
  }

  ngOnInit(): void {
    this.layout.layout.subscribe((res) => {
      if (res == VERTICAL) {
        this.showContent = true;
      }
      if (res == HORIZONTAL) {
        this.showContent = false;
      }
      if (res == COMPACT) {
        this.showContent = false;
      }
    });

    this._authSrcSrv
      .auth$
      .pipe(
        catchError(() => of(null)),
        tap(auth => !auth?.user && this._redirectToHome()),
        tap(auth => this.user = auth?.user),
        tap(auth => this.property = auth?.property)
      ).subscribe();
  }

  clickChangeProperty(){
    this._dialog.open(ChangePropertyDialogComponent, {
      data: { },
      autoFocus: false, disableClose: true
    });
  }

  private _redirectToHome() {

    this._router.navigate(['']);
  }
}
